import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import {Observable,pipe} from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class NestService {
    private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
    clientcredentialheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
    'Authorization': this.getClientCredential()});
     authcredheader: any;
constructor(private http: Http ,@Inject(PLATFORM_ID) private platformId: Object) {
  }
  getClientCredential(){
    var Bearer= 'Bearer' + ' ' + this.cdtk;
    return Bearer;
  }
getAuthCredential(){
  if (isPlatformBrowser(this.platformId)) {
    var a = localStorage.getItem("token");
    var tjson =JSON.parse(a);
    if(tjson != null){
      var auth= 'Bearer' + ' ' +  tjson.token;
      return auth;
    }
  }
  }
  genAuthHeader(){
    this.authcredheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json',
    'Authorization': this.getAuthCredential()})
  }
  getAllRooms(cid){
      this.genAuthHeader();
      return this.http.get('https://passport.petcart.in/nestrooms?city_id=' +cid,
      {headers: this.authcredheader})
      .pipe(map(
          (response:Response)=>{
            return response.json().data;
          })
        );
   }
   createNestRoom(cid,name,type,fees,status){
    this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/nestrooms',
    {name:name,type:type,fees:fees, status:status,city_id:cid},
    {headers: this.authcredheader})
    .pipe(map(
        (response:Response)=>{
          return response.json().data;
        })
      );
   }
   getRoomDetail(rid){
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/nestrooms/' + rid,
    {headers: this.authcredheader})
    .pipe(map(
        (response:Response)=>{
          return response.json().data;
        })
      );
   }
   editnestinfo(rid,name, type,fees){
     this.genAuthHeader();
      return this.http.put('https://passport.petcart.in/nestrooms/' + rid,
       {name:name, type:type,fees:fees},
      {headers:this.authcredheader})
      .pipe(map(
        (response:Response) =>{
          return response.json().data;
        })
      );
    }
    getnestServices(){
      this.genAuthHeader();
      return this.http.get('https://passport.petcart.in/nestservice',
      {headers: this.authcredheader})
      .pipe(map(
          (response:Response)=>{
            return response.json().data;
          })
        );
    }
    createNewNestservice(name,fees,desc,ptype,tid){
      this.genAuthHeader();
      return this.http.post('https://passport.petcart.in/nestservice',
      {name:name,fees:fees,description:desc,pet_type:ptype,
      type_id:tid},
      {headers: this.authcredheader})
      .pipe(map(
          (response:Response)=>{
            return response.json().data;
          })
        );
    }
    getNestServiceDetail(sid){
      return this.http.get('https://passport.petcart.in/nestservice/' + sid,
      {headers: this.authcredheader})
      .pipe(map(
          (response:Response)=>{
            return response.json().data;
          })
        );
    }
    editnestservice(sid,name,fees,desc,ptype){
      this.genAuthHeader();
       return this.http.put('https://passport.petcart.in/nestservice/' + sid,
        {name:name, fees:fees,Description:desc,pet_type:ptype},
       {headers:this.authcredheader})
       .pipe(map(
         (response:Response) =>{
           return response.json().data;
         })
        );
     }
     getNestRoomAvailablity(checkin,checkout,room,cid){
      this.genAuthHeader();
      return this.http.post('https://passport.petcart.in/checkcageavailablity',
      {checkin:checkin,checkout:checkout,room:room,city_id:cid},
      {headers: this.authcredheader})
      .pipe(map(
          (response:Response)=>{
            return response.text();
          })
        );
     }
     BookingRooms(city_id,booking_no,user_id,petparent_name,contact,pet_name,totalroom,
      checkindate,checkoutdate,amount,discount, totalpayable,payment_status,booking_status,booking_type,
      coupon_id,alternetcontact,vetname,
      vetcontact,pickup_service,drop_service,disclaimer){
       var cage_id = "0";
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/nestbooking',
      {city_id:city_id,booking_no:booking_no,user_id:user_id,petparent_name,contact:contact,booking_for:pet_name,
      no_of_rooms: totalroom,check_in:checkindate,check_out:checkoutdate,amount:amount,discount:discount,
    payable:totalpayable,payment_status:payment_status,booking_status:booking_status,booking_type:
      booking_type,cage_id:cage_id,coupon_id:coupon_id,alternetcontact:alternetcontact,
    vet_name:vetname,vet_contact:vetcontact,pickup_service:pickup_service,drop_service:drop_service,
  disclaimer:disclaimer},
    {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
    }
    createNestBookingPetInfo(petdetail){
      this.genAuthHeader();
      return this.http.post('https://passport.petcart.in/nestbookingwithpets',
       {pets: petdetail},
       {headers:this.authcredheader})
  .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    addPickAndDrop(bno,pickuptime,pickupadd,droptime,
      dropadd,count,ps,ds){
        return this.http.post('https://passport.petcart.in/nestpickupanddrop',
        {booking_no:bno,pickup_time:pickuptime,pickup_address:pickupadd,
        drop_time:droptime,drop_address:dropadd,count:count,pickup_status:ps,drop_status:ds},
        {headers:this.authcredheader})
   .pipe(map(
     (response:Response)=>{
       return response.json().data;
     })
    );
      }
    confirmBookingServices(bno,availservice){
      this.genAuthHeader();
      return this.http.post('https://passport.petcart.in/nestbookingservice',
    {booking_no:bno, services:availservice},
    {headers:this.authcredheader})
  .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    getAllNestBooking(city_id){
      this.genAuthHeader();
      return this.http.get('https://passport.petcart.in/nestbooking?sort_bydesc=created_at&city_id=' +city_id,
       {headers:this.authcredheader})
  .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    getBookingDetail(bno){
      this.genAuthHeader();
      return this.http.get('https://passport.petcart.in/nestbooking?booking_no=' + bno,
    {headers:this.authcredheader})
  .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    getBookingServices(bno){
      this.genAuthHeader();
      return this.http.get('https://passport.petcart.in/nestbookingservice?booking_no=' + bno,
    {headers:this.authcredheader})
  .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    AsignedRoomToBooking(id,res){
      this.genAuthHeader();
      return this.http.put('https://passport.petcart.in/nestbooking/' + id,
      {cage_id: res},
    {headers:this.authcredheader})
  .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    changeBookingStatus(id,stat){
      this.genAuthHeader();
      return this.http.put('https://passport.petcart.in/nestbooking/' + id,
      {booking_status: stat},
    {headers:this.authcredheader})
    .pipe(map(
    (response:Response)=>{
      return response.json().data;
    })
  );
    }
    createPackage(type,startdate,enddate,name,desc,
      amount,avail){
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/nestpackage',
        {name:name, description:desc,amount:amount,start_date:startdate,
        end_date:enddate,type:type,availablity:avail},
      {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }
      editPackage(pid,startdate,enddate,name,desc,
        amount,avail){
          console.log(pid,startdate,enddate,name,desc,
            amount,avail)
          this.genAuthHeader();
          return this.http.put('https://passport.petcart.in/nestpackage/' + pid,
          {name:name, description:desc,amount:amount,start_date:startdate,
          end_date:enddate,availablity:avail},
        {headers:this.authcredheader})
      .pipe(map(
        (response:Response)=>{
          return response.json().data;
        })
      );
        }
      getNestPackages(){
        return this.http.get('https://passport.petcart.in/nestpackage',
      {headers:this.clientcredentialheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }
      getpackagedetail(pid){
        return this.http.get('https://passport.petcart.in/nestpackage/' + pid,
        {headers:this.clientcredentialheader})
      .pipe(map(
        (response:Response)=>{
          return response.json().data;
        })
      );
      }
      createNestRoomOption(name,desc,amount,minval,ptype){
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/nestroombookingoption',
        {name:name, description:desc,fees:amount,minval:minval,
        pet_type:ptype},
      {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }
      getNestRoomBookingOption(){
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/nestroombookingoption',
      {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }
      getRoomOptionDetail(opid){
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/nestroombookingoption/' + opid,
      {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }
      editNestRoomOption(name,desc,amount,minval,ptype,opid){
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/nestroombookingoption/' + opid,
        {name:name, description:desc,fees:amount,minval:minval,
        pet_type:ptype},
      {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }
      getUserPets(uid){
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/pets?pet_type=dog&user_id=' + uid,
        {headers:this.authcredheader})
      .pipe(map(
        (response:Response)=>{
          return response.json().data;
        })
      );
      }
      getnestBookingPetDetail(bno){
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/nestbookingwithpets?booking_no='+bno,
         {headers:this.authcredheader})
    .pipe(map(
      (response:Response)=>{
        return response.json().data;
      })
    );
      }

      createuserpet(uid,pname,ptype,bio,dob,image){
        this.genAuthHeader()
        return this.http.post('https://passport.petcart.in/pets',
        {user_id:uid,pet_name:pname,pet_type:ptype,bio:bio,dob:dob,image},
        {headers:this.authcredheader})
        .pipe(map(
          (response:Response)=>{
            return response.json().data;
          })
        );
      }
      getAllCoupon(nest){
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/coupon?type='+nest ,
        {headers: this.authcredheader})
      .pipe(map(
        (response: Response) => {
          
          return response.json().data;
         })
        );
      }
      getNestPetDetails(uid){
        this.genAuthHeader();
      return this.http.get('https://passport.petcart.in/nestbookingwithpets?user_id=' +uid ,
      {headers: this.authcredheader})
      .pipe(map(
      (response: Response) => {
        return response.json().data;
       })
      );
      }

      public getcatProduct(id: number) {
        return this.http.post('https://passport.petcart.in/categoryproduct',
        {category_id: id},
        {headers: this.clientcredentialheader})
        .pipe(map(
          (response: Response) => {
            return response.json();
          })
        );
      }

      updateNestPayment(id, stat, status) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/nestbooking/' + id,
         {payment_status: stat, booking_status: status},
        {headers:this.authcredheader})
        .pipe(map(
          (response:Response) => {
            return response.json().data;
          })
        );
      }

      updateEmergencyContacts(id, altcnt, vetname, vetcontact) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/nestbooking/' + id,
         {alternetcontact: altcnt, vet_name: vetname, vet_contact: vetcontact},
        {headers:this.authcredheader})
        .pipe(map(
          (response:Response) => {
            return response.json().data;
          })
        );
      }


      applyNestCoupon(code, total) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/applynestcoupon' ,
        {headers: this.authcredheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
         })
        );
      }

      getOthernestServices(){
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/nestservice?type_id=9',
        {headers: this.authcredheader})
        .pipe(map(
            (response:Response)=>{
              return response.json().data;
            })
          );
      }

      postNestServiceBooking(name, petname, mobile, email, service, fees, date, time, paymentstats) {
        return this.http.post('https://passport.petcart.in/nestservicebooking',
        {name: name, pet_name: petname, mobile: mobile, email: email, service: service, fees: fees,
          date: date, time: time, payment_status: paymentstats},
        {headers: this.clientcredentialheader})
        .pipe(map(
            (response:Response) => {
              return response.json().data;
            })
          );
       }

}